import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';
import { translate, Interpolate } from 'react-i18next';

const OverviewSection = (props) => (
  <section className="method row" id="overview">
    <div className="method__text method__text--first col-lg-6">
      <h1 className="h2">{props.t('title')}</h1>
      <hr />
      <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />
      {/* <h5>{props.t('authTable.title')}</h5>
      <div className="table-responsive">
        <table className="table">
          <tbody>
            <tr>
              <th></th>
              <th>{props.t('authTable.row1.col2')}</th>
              <th>{props.t('authTable.row1.col3')}</th>
            </tr>
            <tr>
              <th>{props.t('authTable.row2.col1')}</th>
              <td>{props.t('authTable.row2.col2')}</td>
              <td>{props.t('authTable.row2.col3')}</td>
            </tr>
            <tr>
              <th>{props.t('authTable.row3.col1')}</th>
              <td>{props.t('authTable.row3.col2')}</td>
              <td>{props.t('authTable.row3.col3')}</td>
            </tr>
            <tr>
              <th>{props.t('authTable.row4.col1')}</th>
              <td>{props.t('authTable.row4.col2')}</td>
              <td>{props.t('authTable.row4.col3')}</td>
            </tr>
          </tbody>
        </table>
      </div> */}
    </div>
    <div className="method__code col-lg-6">
      <small>{props.t('example.personalDataEndpoint')}</small>
      <SyntaxHighlighter language='text' style={sunburst}>
        {
          `https://mise.se/TestAPI/api/`
        }          
      </SyntaxHighlighter>
      <small>{props.t('example.businessDataEndpoint')}</small>
      <SyntaxHighlighter language='text' style={sunburst}>
        {
          `https://mise.se/TestAPI/api/`
        }          
      </SyntaxHighlighter>
    </div>
  </section>
);

export default translate('OverviewSection')(OverviewSection);



// WEBPACK FOOTER //
// ./src/components/sections/OverviewSection.jsx